export const VPN_TEST_ACCESS_KEY = "pw_vpn_test_access";
export const VPN_TEST_ACCESS_CHANGED_EVENT = "pw-vpn-test-access-changed";

const LOCAL_TEST_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "::1",
]);

function getHostname() {
  if (typeof window === "undefined") return "";
  return String(window.location?.hostname || "").toLowerCase();
}

function getSessionMarker() {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(VPN_TEST_ACCESS_KEY) === "true";
  } catch {
    return false;
  }
}

function notifyAccessChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(VPN_TEST_ACCESS_CHANGED_EVENT));
}

// UI convenience only: this marker can remember that a login response carried
// VPN metadata. It must never be used as the authorization boundary for an
// internal route; those routes require a fresh backend authorization check.
export function rememberVpnTestAccess(responseData = {}) {
  if (typeof window === "undefined") return false;

  const hasVpnSignal =
    responseData?.is_vpn_login === true ||
    responseData?.is_vpn_request === true ||
    responseData?.metadata?.is_vpn_request === true;
  const hasExplicitDenial =
    responseData?.is_vpn_login === false ||
    responseData?.is_vpn_request === false ||
    responseData?.metadata?.is_vpn_request === false;

  try {
    if (hasVpnSignal) {
      window.sessionStorage.setItem(VPN_TEST_ACCESS_KEY, "true");
    } else if (hasExplicitDenial) {
      window.sessionStorage.removeItem(VPN_TEST_ACCESS_KEY);
    }
  } catch {
    return false;
  }

  notifyAccessChanged();
  return hasVpnSignal || getSessionMarker();
}

export function clearVpnTestAccess() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(VPN_TEST_ACCESS_KEY);
  } catch {
    // Storage can be unavailable in privacy-restricted browsers.
  }
  notifyAccessChanged();
}

export function hasVpnTestAccess(hostname = getHostname()) {
  return LOCAL_TEST_HOSTS.has(String(hostname || "").toLowerCase()) || getSessionMarker();
}
